import styled, { createGlobalStyle } from 'styled-components';
import { media } from 'helpers/breakpoints';
import Modal from 'react-modal';
import { Button } from 'components/Toolkit/Button';
import { withOpacity } from 'helpers/Theme/Theme';

const StickyContactSeller = styled.div`
  ${media.large} {
    display: none;
  }
`;

const OverlayStyle = createGlobalStyle`
  .bottom-sheet-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9950;
    display: flex;
    background-color:rgba(0,0,0,0) !important;
    transition: all 200ms ease-in-out;

    &.ReactModal__Overlay--after-open {
     background-color: ${({ theme }) =>
       withOpacity(theme.colors.GREY_DARKER, 0.8)};
    }

    &.ReactModal__Overlay--before-close {
      background-color:rgba(0,0,0,0) !important;
    }
  }
`;

const SBottomSheet = styled(Modal)<{ height: string }>`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: ${({ height }) => height} !important;
  z-index: 9950;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.WHITE};
  border-radius: ${({ theme }) =>
    `${theme.borderRadius.default} ${theme.borderRadius.large} 0 0`};
  transform: translateY(100%);
  transition: all 0.2s ease-in-out;

  .ReactModal__Overlay--after-open & {
    transform: translateY(0);
  }

  .ReactModal__Overlay--before-close & {
    transform: translateY(100%);
  }

  ${media.large} {
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%, -50%);
    border-radius: ${({ theme }) => `${theme.borderRadius.large} `};

    .ReactModal__Overlay--after-open & {
      transform: translate(-50%, -50%);
    }

    .ReactModal__Overlay--before-close & {
      transform: translate(-50%, -50%);
    }
  }

  :focus {
    outline: none;
  }
`;

const SBottomSheetInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const DialogHeader = styled.div`
  padding: ${({ theme }) => `${theme.spacing.M24} ${theme.spacing.M24} 0`};

  ${media.large} {
    padding: ${({ theme }) => `${theme.spacing.L48} ${theme.spacing.L48} 0`};
  }
`;

const DialogHeaderText = styled.span`
  ${({ theme }) => theme.fontSize.B18};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const DialogBody = styled.div`
  flex: 1 1 100%;
  height: 100%;
  overflow: auto;
  gap: ${({ theme }) => `${theme.spacing.S8}`};
  flex-direction: column;
  display: flex;
  padding: ${({ theme }) => theme.spacing.M24};

  ${media.large} {
    padding: ${({ theme }) =>
      `${theme.spacing.M24} ${theme.spacing.L48} ${theme.spacing.L48}`};
  }
`;

const SButtonWhatsApp = styled(Button)`
  color: ${({ theme }) => theme.colors.GREEN};
  border-color: ${({ theme }) => theme.colors.GREEN};
  svg {
    margin-right: ${({ theme }) => `${theme.spacing.S8}`};
  }

  &:active,
  &:hover {
    svg {
      color: ${({ theme }) => theme.colors.BLUE};
    }
    border-color: ${({ theme }) => theme.colors.BLUE};
  }
`;

const Close = styled.span`
  top: ${({ theme }) => theme.spacing.M24};
  right: ${({ theme }) => theme.spacing.M24};
  color: ${({ theme }) => theme.colors.GREY_DARKER};
  position: absolute;
  padding: 0;
  cursor: pointer;
`;

export {
  SBottomSheet,
  SBottomSheetInner,
  SButtonWhatsApp,
  StickyContactSeller,
  OverlayStyle,
  Close,
  DialogBody,
  DialogHeader,
  DialogHeaderText,
};
